import {Col, Row, Button, Form, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import ApiService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";
import {useLocation, useNavigate} from "react-router-dom";
import AppRoute from "../../utils/AppRoute";
import eventBus from "../../utils/EventBus";

const Cart = () => {

    const [basket, setBasket] = useState({});
    // eslint-disable-next-line no-unused-vars
    const [coupon, setCoupon] = useState({});
    const [activeCoupon, setActiveCoupon] = useState();
    const location = useLocation();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [cartTableRows, setCartTableRows] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async () => {
        try {
            const activeBasket = await ApiService.getBasketData();
            let couponData;

            if(activeBasket.couponId){
               couponData  = await ApiService.getCouponById(activeBasket.couponId);
            }
            const cartRowPromises = activeBasket.bookCourses.map((bookCourse) => {
                const coursePromise = ApiService.getCourseById(bookCourse.courseId);
                const participantPromise = ApiService.getParticipantById(
                    bookCourse.participantId
                );

                return Promise.all([coursePromise, participantPromise]).then(
                    ([course, participant]) => {
                        return ApiService.getLevelById(course.levelCourseId).then((level) => {
                            return (
                                <tr
                                    key={`${bookCourse.id}`}
                                    className={"border-end border-start"}
                                >
                                    <td className={"border-end"}>
                                        {course.title},<br />
                                        {level.level}
                                        <br />
                                        {course.durationInMinutes}
                                    </td>
                                    <td className={"border-end"}>
                                        {participant.firstName} {participant.lastName}
                                        <br />
                                        {DateTimeUtils.getParticipantDob(participant)}
                                        <br />
                                        Livello {participant.currentLevel}
                                    </td>
                                    <td>
                                        <div className={"text-end"}>
                                            {parseFloat(course.price).toFixed(2)} CHF
                                            <br />
                                            <br />
                                        </div>
                                        <div className={"text-end"}>
                                            <Button
                                                variant={"link"}
                                                onClick={(e) => handleEliminaCartItem(e, bookCourse.id)}
                                                className={"p-0"}
                                            >
                                                elimina
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            );
                        });
                    }
                );
            });

            const cartRows = await Promise.all(cartRowPromises);
            setBasket(activeBasket);
            setActiveCoupon(couponData);
            setCartTableRows(cartRows);
            setDataLoaded(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    const handleEliminaCartItem = (e, bookId) => {
        e.preventDefault();

        ApiService.deleteBookCourse(bookId).then(res => {
            eventBus.dispatch("bookCourseDeleted");
            getData();
        })
    }

    const checkDataBeforeCheckout = event => {
        event.preventDefault();

        setShowAddressModal(true)
    }

    const handleValidateCoupon = (e) =>{
        e.preventDefault();

       ApiService.linkCouponToBasket(coupon, basket.id)
           .then(response => window.location.reload())
    }

    const getCouponImport = () => {
        if(activeCoupon){
            return activeCoupon.discount === 0? `${activeCoupon.cost} CHF` : `${activeCoupon.discount}%`
        } else {
            return "-"
        }
    }

    return (
        <>
            <div key={location.key}>
            <Row>
                <Col lg={6}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Carrello</h2>
                        </Col>
                    </Row>

                    {dataLoaded && cartTableRows.length > 0 ?
                        <Row className={'pt-5 my-5'}>
                            <Col xs={12}>
                                <table className="table mb-3">
                                    <thead className={'border-end border-start border-top'}>
                                    <tr>
                                        <th scope={'col'}>Corso</th>
                                        <th scope={'col'}>Partecipante</th>
                                        <th scope={'col'} className={'text-end'}>Prezzo</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {cartTableRows}
                                    <tr className={'fw-bold border-end border-start'}>
                                        <td colSpan={2}>Sconti applicati</td>
                                        <td className={'text-end'}>{basket && basket.discountApplied? "10%": "-"}</td>
                                    </tr>
                                    <tr className={'fw-bold border-end border-start'}>
                                        <td className={'align-middle'}>Buoni</td>
                                        <td>
                                            <Form>
                                                <Form.Control type='text' className={'mb-2 px-2'} placeholder="Buono" onChange={(e) => setCoupon(e.target.value)}/>
                                                <Button variant={'primary'} onClick={(e) => handleValidateCoupon(e)}
                                                        className={'mb-2 px-2 fw-bold text-uppercase'}>Applica</Button>
                                            </Form>
                                        </td>
                                        <td className={'text-end align-middle'}>{activeCoupon && getCouponImport()}</td>
                                    </tr>
                                    <tr className={'fw-bold border-end border-start'}>
                                        <td colSpan={2}>Totale</td>
                                        <td className={'text-end'}>{parseFloat(basket.total).toFixed(2)} CHF</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </Col>
                            <Col xs={12}>
                                <p className={'fw-bold'}>
                                    *Pagamento solo con CARTE DI CREDITO o TWINT - non si possono registrare versamenti bancari diretti
                                </p>
                                <div className={'d-flex justify-content-end'}>
                                    <Button variant={'primary'} onClick={e => checkDataBeforeCheckout(e)}
                                            className={'px-4 fw-bold'}>Vai al pagamento</Button>
                                </div>


                            </Col>
                        </Row>
                        :
                        <p className={'mt-5 mb-2'}>Il carrello è vuoto</p>
                    }
                </Col>

                <Modal show={showAddressModal} onHide={() => setShowAddressModal(false)} backdrop='static'
                       keyboard="False" size="lg" centered>
                    <Modal.Header className={'justify-content-end py-0'}>
                        <Button variant={'link'} onClick={() => setShowAddressModal(false)}>
                            chiudi x
                        </Button>
                    </Modal.Header>
                    <Modal.Body className={'mt-4 mb-5'}>
                        <h2 className={'title fw-bold'}>Conferma le informazioni</h2>
                        <p>Prima di procedere con l'acquisto è necessario registrare o confermare un indirizzo.</p>
                        <Button variant={'primary'} className={'px-5 fw-bold'}
                                onClick={() => navigate(AppRoute.ADDRESS, {state: {checkout: true}})}>
                            Continua
                        </Button>
                    </Modal.Body>
                </Modal>
            </Row>
            </div>
        </>

    );
}

export default Cart;
